/**
 * Field holding a series' price, named by index instead of by provider.
 *
 * The tooltip template references it as `{price_3}`, and provider names can
 * carry spaces ("sixt insurance") which would break that parsing.
 */
export const priceField = index => `price_${index}`

/**
 * Flattens `chartData` into one rank value per provider and date, plus the
 * price behind each rank so the tooltip can show both.
 *
 * A provider with no rate that day simply has no key in the row, so the value
 * stays `undefined` and the line breaks instead of dropping to zero.
 */
export const buildRankData = (chartData = [], dataKeys = []) => chartData.map(row => {
	const flat = { date: row.date }

	dataKeys.forEach((key, index) => {
		flat[key] = row[key]?.pricePosition
		flat[priceField(index)] = row[key]?.price
	})

	return flat
})

/** Worst rank reached across the whole window, used to size the axis. */
export const getMaxRank = (rankData = [], dataKeys = []) => dataKeys.reduce((max, key) => {
	const worst = rankData.reduce((acc, row) =>
		typeof row[key] === 'number' && row[key] > acc ? row[key] : acc, max)

	return worst > max ? worst : max
}, 1)

/** The provider flagged as `isMainData` in any row of `chartData`. */
export const findMainDataKey = (chartData = [], dataKeys = []) => {
	for (const row of chartData) {
		const key = dataKeys.find(k => row[k]?.isMainData)

		if (key) return key
	}

	return null
}
